export { default } from './EmprestimoGarantiaCarroBanner';
